import BubbleIcon from '@/assets/bubble.svg?react'
import { Button } from '@mantine/core'
import clsx from 'clsx'
import { isEmpty } from 'lodash-es'
import type { HTMLAttributes } from 'react'
import { Controller, useWatch } from 'react-hook-form'
import styles from './SubmitButton.module.css'
import type { RepostFormValue } from './types'

export interface SubmitButtonGroupProps extends HTMLAttributes<HTMLDivElement> {
	isLoading?: boolean
}

export default function SubmitButtonGroup({
	isLoading,
	className,
	...props
}: SubmitButtonGroupProps) {
	const content = useWatch<RepostFormValue, 'content'>({
		name: 'content',
	})
	const syncComment = useWatch<RepostFormValue, 'syncComment'>({
		name: 'syncComment',
	})
	const isDisabled = syncComment ? isEmpty(content) : false
	return (
		<div className={clsx(styles.container, className)} {...props}>
			<Controller
				name="syncComment"
				render={({ field }) => (
					<Button
						onClick={() => field.onChange(!field.value)}
						variant={field.value ? 'filled' : 'outline'}
						className={styles.button}
						size="sm"
					>
						<BubbleIcon className={styles.icon} color="currentColor" />
					</Button>
				)}
			/>

			<Button size="sm" type="submit" disabled={isLoading || isDisabled} loading={isLoading}>
				转发动态{syncComment && '并评论'}
			</Button>
		</div>
	)
}
